import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    this.tomSelect = new TomSelect(this.element, {
      plugins: ['remove_button'],
      maxItems: null,
      valueField: 'id',
      labelField: 'name',
      searchField: ['name'],
      create: false,
      render: {
        option: function(data, escape) {
          return `<div class="flex items-center">
                    <span class="grow">${escape(data.name)}</span>
                  </div>`
        },
        item: function(data, escape) {
          return `<div class="flex items-center">
                    <span class="grow">${escape(data.name)}</span>
                  </div>`
        }
      }
    })
  }

  disconnect() {
    this.tomSelect.destroy()
  }
}
